import script from "./AnswerList.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerList.vue?vue&type=script&setup=true&lang=js"

import "./AnswerList.vue?vue&type=style&index=0&id=af84ec06&scoped=true&lang=css"
script.__scopeId = "data-v-af84ec06"

export default script